export default function normalizeCombatLookupImage(assetUrl) {
  if (!assetUrl) {
    return assetUrl
  }

  if (/^https?:\/\//i.test(assetUrl)) {
    return assetUrl
  }

  let normalizedPath = String(assetUrl).trim()

  if (!normalizedPath) {
    return null
  }

  const isKnownLookupPath = /^(\/)?(markers|statuses|fatigues|visibility)\//i.test(normalizedPath)

  if (normalizedPath.startsWith('/') && isKnownLookupPath) {
    normalizedPath = `/media${normalizedPath}`
  }

  if (!normalizedPath.startsWith('/')) {
    normalizedPath = normalizedPath.startsWith('media/')
      ? `/${normalizedPath}`
      : `/media/${normalizedPath}`
  }

  const baseUrl =
    import.meta.env.VITE_API_URL || (typeof window !== 'undefined' ? window.location.origin : '')

  if (!baseUrl) {
    return normalizedPath
  }

  try {
    return new URL(normalizedPath, baseUrl).toString()
  } catch {
    return normalizedPath
  }
}
